/* ==========================================================================
   Tenace (22/10/2026): añadir al carrito desde la tarjeta de producto.

   Master no lo trae. El marcado lo pinta snippets/tenace-tarjeta-carrito.liquid
   (dentro de la foto de cada tarjeta, con el formulario form[data-tenace-qa])
   y los estilos están en custom.css.liquid (sección 5).

   - Selector: una fila de valores por cada opción con varios valores. Con lo
     elegido se busca la variante (JSON [data-tenace-qa-variantes]) y se pone su
     id en input[name=id]. Los valores sin variante disponible con lo ya
     elegido se tachan pero se pueden pulsar: al elegir uno, se desmarca lo que
     no encaja en las otras filas (si se desactivaran, con stock "en diagonal"
     el cliente podría quedarse sin forma de cambiar de talla).
   - Con ratón el formulario aparece dentro de la foto al pasar el ratón (CSS).
   - Sin ratón, el "+" ([data-tenace-qa-mas]): con variantes MUEVE el formulario
     a un panel inferior (#tenace-qa-hoja, en el body, para que no le afecten
     los transform de los carruseles) y deja en la tarjeta una COPIA; al cerrar
     lo devuelve. Si mientras tanto la tarjeta se ha vuelto a pintar ("Cargar
     más", filtros), la tarjeta nueva ya tiene su propia copia y el original se
     descarta. Sin variantes, el "+" añade directamente.
   - Errores: dentro del formulario si se ve (panel abierto, o con el ratón
     encima); si no, en un aviso flotante (#tenace-qa-aviso-flotante).

   La petición la hace este script y no addItemToCart de global.js, porque esa
   función no limpia la ruedita si la red falla, con un error fuera de pantalla
   salta al PRIMER aviso del documento y obliga a poner data-add-to-cart, que
   el tema engancha por su cuenta (doble añadido). Para abrir el carrito
   lateral se copian sus pasos y se usan sus funciones globales
   (sideDrawerInt, focusElementsRotation, updateCartHtml): si el tema cambia
   esa parte, revisar abrirCarrito().

   Todo va por delegación en document, en burbuja: funciona con tarjetas que
   llegan después (filtros, orden, "Cargar más", recomendados) y respeta a
   Slick, que anula el clic tras arrastrar un carrusel.
   ========================================================================== */
(function () {
  if (window.tenaceQuickAdd) return;
  window.tenaceQuickAdd = true;

  var ESPERA_MAXIMA = 15000;
  var envios = 0;
  var textos = window.tenaceTextos || {};

  /* ---------- utilidades ---------- */

  // /cart, también con prefijo de idioma (/en/cart). El tema usa
  // indexOf('/cart'), que también acierta en /collections/carteras.
  function esPaginaCarrito() {
    return /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?cart\/?$/i.test(window.location.pathname);
  }

  // Quita la carga. Por marca y no por referencia: "Cargar más" vuelve a crear
  // las tarjetas con innerHTML y el botón nuevo hereda la clase.
  function terminar(marca) {
    document.querySelectorAll('[data-tenace-qa-envio="' + marca + '"]').forEach(function (b) {
      b.classList.remove('loading');
      b.removeAttribute('data-tenace-qa-envio');
      b.removeAttribute('aria-busy');
    });
  }

  function variantes(form) {
    if (form._tenaceVariantes) return form._tenaceVariantes;
    var nodo = form.querySelector('[data-tenace-qa-variantes]');
    try { form._tenaceVariantes = nodo ? JSON.parse(nodo.textContent) : []; } catch (e) { form._tenaceVariantes = []; }
    return form._tenaceVariantes;
  }

  function enHoja(form) {
    return !!(abierta && abierta.form === form);
  }

  /* ---------- avisos ---------- */

  function aviso(form, texto) {
    var p = form.querySelector('.tenace-qa-aviso');
    if (p) p.textContent = texto || '';
  }

  var flotante = null;
  var relojFlotante = null;
  function avisoFlotante(texto) {
    if (!flotante) {
      flotante = document.createElement('div');
      flotante.id = 'tenace-qa-aviso-flotante';
      flotante.className = 'tenace-qa-aviso-flotante';
      flotante.setAttribute('role', 'alert');
      document.body.appendChild(flotante);
    }
    flotante.textContent = texto;
    flotante.classList.add('is-visible');
    clearTimeout(relojFlotante);
    relojFlotante = setTimeout(function () { flotante.classList.remove('is-visible'); }, 6000);
  }

  // Errores al añadir: en el formulario si el cliente lo está viendo; si no
  // (el "+" de móvil, que no enseña el formulario, o el ratón ya fuera y el
  // formulario plegado), en el aviso flotante. Se mira si se ve de verdad, no
  // si hay ratón: el editor de temas enseña la vista de móvil con ratón.
  function avisoError(form, texto) {
    var visible = enHoja(form) || (form.offsetParent !== null && form.getBoundingClientRect().height > 1);
    if (visible) {
      aviso(form, texto);
    } else {
      aviso(form, '');
      avisoFlotante(texto);
    }
  }

  /* ---------- selector de variantes ---------- */

  // Lo elegido en cada fila: { indiceDeOpcion: valor }
  function eleccion(form) {
    var elegido = {};
    form.querySelectorAll('.tenace-qa-grupo').forEach(function (g) {
      var marcado = g.querySelector('input[type="radio"]:checked');
      if (marcado) elegido[g.getAttribute('data-indice')] = marcado.value;
    });
    return elegido;
  }

  function encaja(variante, elegido, salvoIndice) {
    for (var i in elegido) {
      if (i === salvoIndice) continue;
      if (variante.o[Number(i)] !== elegido[i]) return false;
    }
    return true;
  }

  // Recalcula: si se acaba de elegir algo (cambiado), desmarca en las otras
  // filas lo que no encaja; tacha lo que no tiene variante disponible con lo
  // elegido; pone el id de la variante y marca si la elección está completa.
  function actualizar(form, cambiado) {
    var grupos = form.querySelectorAll('.tenace-qa-grupo');
    if (!grupos.length) return;
    var lista = variantes(form);

    if (cambiado && grupos.length > 1) {
      var indiceCambiado = cambiado.closest('.tenace-qa-grupo').getAttribute('data-indice');
      grupos.forEach(function (g) {
        var indice = g.getAttribute('data-indice');
        if (indice === indiceCambiado) return;
        var marcado = g.querySelector('input[type="radio"]:checked');
        if (!marcado) return;
        var conjunto = {};
        conjunto[indiceCambiado] = cambiado.value;
        conjunto[indice] = marcado.value;
        var posible = lista.some(function (v) { return v.a && encaja(v, conjunto, null); });
        if (!posible) marcado.checked = false;
      });
    }

    var elegido = eleccion(form);
    if (grupos.length > 1) {
      grupos.forEach(function (g) {
        var indice = g.getAttribute('data-indice');
        g.querySelectorAll('input[type="radio"]:not(:disabled)').forEach(function (input) {
          var posible = lista.some(function (v) {
            return v.a && v.o[Number(indice)] === input.value && encaja(v, elegido, indice);
          });
          input.closest('.tenace-qa-valor').classList.toggle('is-agotado', !posible);
        });
      });
    }

    var completo = Object.keys(elegido).length === grupos.length;
    var variante = null;
    if (completo) {
      for (var k = 0; k < lista.length; k++) {
        if (lista[k].a && encaja(lista[k], elegido, null)) { variante = lista[k]; break; }
      }
    }
    var campo = form.querySelector('input[name="id"]');
    if (campo) campo.value = variante ? variante.id : '';
    form.classList.toggle('tenace-qa--completo', !!variante);
  }

  // Estado limpio la primera vez que se usa un formulario. Lo que se guarda
  // en propiedades JS no pasa al HTML, así que una tarjeta vuelta a pintar con
  // innerHTML ("Cargar más") se prepara otra vez y no arrastra clases ni el id
  // del estado anterior.
  function preparar(form) {
    if (!form || form._tenaceListo) return;
    form._tenaceListo = true;
    form.classList.remove('tenace-qa--pedir');
    if (form.querySelector('.tenace-qa-grupo')) actualizar(form);
  }

  function primeraFilaSinElegir(form) {
    var grupos = form.querySelectorAll('.tenace-qa-grupo');
    for (var i = 0; i < grupos.length; i++) {
      if (!grupos[i].querySelector('input[type="radio"]:checked')) return grupos[i];
    }
    return grupos[0] || null;
  }

  /* ---------- panel inferior (sin ratón) ---------- */

  var hoja = null;
  var abierta = null; // { form, copia, disparador }

  function crearHoja() {
    if (hoja) return hoja;
    hoja = document.createElement('div');
    hoja.className = 'tenace-qa-hoja';
    hoja.id = 'tenace-qa-hoja';
    hoja.hidden = true;
    hoja.innerHTML =
      '<div class="tenace-qa-hoja-fondo" data-tenace-qa-cerrar></div>' +
      '<div class="tenace-qa-hoja-panel" role="dialog" aria-modal="true" aria-labelledby="tenace-qa-hoja-titulo">' +
        '<div class="tenace-qa-hoja-cabecera">' +
          '<p class="tenace-qa-hoja-titulo" id="tenace-qa-hoja-titulo"></p>' +
          '<button type="button" class="tenace-qa-hoja-cerrar" data-tenace-qa-cerrar>' +
            '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M2 2l12 12M14 2L2 14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>' +
          '</button>' +
        '</div>' +
        '<div class="tenace-qa-hoja-cuerpo"></div>' +
      '</div>';
    hoja.querySelector('.tenace-qa-hoja-cerrar').setAttribute('aria-label', textos.cerrar || 'Cerrar');
    document.body.appendChild(hoja);
    return hoja;
  }

  function abrirHoja(form, disparador) {
    if (abierta) cerrarHoja(false);
    crearHoja();
    preparar(form);
    aviso(form, '');
    form.classList.remove('tenace-qa--pedir');
    // En la tarjeta queda una copia (no un hueco) por si se vuelve a pintar
    // mientras el panel está abierto.
    var copia = form.cloneNode(true);
    form.parentNode.replaceChild(copia, form);
    hoja.querySelector('.tenace-qa-hoja-cuerpo').appendChild(form);
    hoja.querySelector('.tenace-qa-hoja-titulo').textContent = form.getAttribute('data-titulo-hoja') || '';
    abierta = { form: form, copia: copia, disparador: disparador };
    hoja.hidden = false;
    // Unos ms sin admitir toques: un doble toque en "+" cerraba el panel o
    // marcaba una talla mientras subía.
    hoja.classList.add('is-abriendo');
    setTimeout(function () { if (hoja) hoja.classList.remove('is-abriendo'); }, 400);
    document.documentElement.classList.add('tenace-qa-hoja-abierta');
    requestAnimationFrame(function () {
      if (abierta && abierta.form === form) hoja.classList.add('is-abierta');
    });
    var primero = form.querySelector('input[type="radio"]:checked, input[type="radio"]:not(:disabled)') ||
      hoja.querySelector('.tenace-qa-hoja-cerrar');
    if (primero) primero.focus({ preventScroll: true });
  }

  function cerrarHoja(devolverFoco) {
    if (!abierta) return;
    var datos = abierta;
    abierta = null;
    hoja.classList.remove('is-abierta', 'is-abriendo');
    hoja.hidden = true;
    document.documentElement.classList.remove('tenace-qa-hoja-abierta');
    datos.form.classList.remove('tenace-qa--pedir');
    aviso(datos.form, '');
    // De vuelta a su tarjeta, en el sitio de la copia. Si la tarjeta se ha
    // vuelto a pintar, la copia ya no está y la tarjeta nueva tiene la suya.
    if (datos.copia.isConnected) {
      datos.copia.parentNode.replaceChild(datos.form, datos.copia);
    } else {
      datos.form.remove();
    }
    if (devolverFoco !== false && datos.disparador && datos.disparador.isConnected) datos.disparador.focus({ preventScroll: true });
  }

  /* ---------- carrito ---------- */

  function irAlCarrito(form) {
    window.location.href = form.getAttribute('data-url-carrito') || '/cart';
  }

  // Mismos pasos que el éxito de addItemToCart (assets/global.js).
  function abrirCarrito(form, boton, cart, sectionId) {
    var html = cart.sections && cart.sections[sectionId];
    if (!html) { irAlCarrito(form); return; }
    var nuevo = new DOMParser().parseFromString(html, 'text/html');
    var seccionCarrito = document.querySelector('[data-cart-content]');

    if (esPaginaCarrito()) {
      if (typeof updateCartHtml === 'function' && seccionCarrito) {
        updateCartHtml(seccionCarrito, cart, sectionId);
        window.scrollTo({ top: seccionCarrito.offsetTop, behavior: 'smooth' });
      } else {
        window.location.reload();
      }
      return;
    }

    var cajon = document.querySelector('#cart-side-drawer');
    var contenido = document.querySelector('[data-cart-drawer]');
    var contenidoNuevo = nuevo.querySelector('[data-cart-drawer]');
    if (form.getAttribute('data-carrito-lateral') === 'false' || !cajon || !contenido || !contenidoNuevo) {
      irAlCarrito(form);
      return;
    }
    contenido.innerHTML = contenidoNuevo.innerHTML;
    if (typeof sideDrawerInt === 'function') sideDrawerInt();
    cajon.style.display = 'flex';
    document.body.classList.add('no-scroll');
    setTimeout(function () { cajon.classList.add('show'); }, 500);
    try {
      if (typeof previousFocusElement !== 'undefined' && previousFocusElement == '') previousFocusElement = boton;
    } catch (e) {}
    setTimeout(function () {
      if (typeof focusElementsRotation === 'function') focusElementsRotation(contenido);
    }, 1000);
    if (typeof updateCartHtml === 'function') updateCartHtml(seccionCarrito, cart, sectionId);
  }

  function enviar(form, boton) {
    var id = (form.querySelector('input[name="id"]') || {}).value;
    if (!id) return;
    envios += 1;
    var marca = envios + '-' + Date.now();
    boton.setAttribute('data-tenace-qa-envio', marca);
    boton.setAttribute('aria-busy', 'true');
    boton.classList.add('loading');
    aviso(form, '');

    var datos = new FormData();
    datos.append('id', id);
    datos.append('quantity', '1');
    var sectionId = 'ajax-cart';
    if (esPaginaCarrito()) {
      var seccion = document.querySelector('[data-cart-content]');
      if (seccion && seccion.dataset.section) sectionId = seccion.dataset.section;
    }
    datos.append('sections', sectionId);

    var url = (typeof cartAddUrl !== 'undefined' && cartAddUrl) ? cartAddUrl : '/cart/add.js';
    var corte = window.AbortController ? new AbortController() : null;
    var reloj = setTimeout(function () { if (corte) corte.abort(); }, ESPERA_MAXIMA);

    fetch(url, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' },
      body: datos,
      signal: corte ? corte.signal : undefined
    })
      .then(function (respuesta) { return respuesta.json(); })
      .then(function (cart) {
        if (cart && cart.status) {
          // Error de Shopify (sin stock, ya tienes todas las unidades...)
          avisoError(form, cart.description || cart.message || form.getAttribute('data-aviso-error'));
          return;
        }
        // Cualquier panel abierto (de esta tarjeta o de otra) se cierra antes:
        // el carrito lateral quedaría debajo.
        if (abierta) cerrarHoja(false);
        abrirCarrito(form, boton, cart, sectionId);
      })
      .catch(function () {
        // Sin red, respuesta que no es JSON (5xx, 429...) o más de 15 s
        avisoError(form, form.getAttribute('data-aviso-error'));
      })
      .then(function () {
        clearTimeout(reloj);
        terminar(marca);
      });
  }

  /* ---------- eventos ---------- */

  // Preparar el formulario la primera vez que se pasa el ratón o el foco.
  function prepararDesde(evento) {
    var capa = evento.target.closest && evento.target.closest('.tenace-qa-capa');
    if (capa) preparar(capa.querySelector('form[data-tenace-qa]'));
  }
  document.addEventListener('mouseover', prepararDesde);
  document.addEventListener('focusin', prepararDesde);

  // Con ratón, al desplegarse el formulario el botón ocupa el sitio donde
  // estaba el ojo. Si el ratón llega al ojo nada más entrar en la tarjeta
  // (antes de que empiece a desplegarse: el CSS espera 0,2 s), la capa queda
  // quieta mientras siga encima del ojo, para que el clic sea la vista rápida
  // y no "Añadir al carrito". Al salir del ojo se despliega con normalidad.
  document.addEventListener('mouseover', function (evento) {
    var tarjeta = evento.target.closest && evento.target.closest('.product-card');
    if (!tarjeta) return;
    var capa = tarjeta.querySelector('.tenace-qa-capa');
    if (!capa) return;
    if (!evento.relatedTarget || !tarjeta.contains(evento.relatedTarget)) capa._tenaceEntrada = Date.now();
    var enOjo = !!evento.target.closest('.tenace-qa-ojo');
    if (enOjo && capa._tenaceEntrada && Date.now() - capa._tenaceEntrada < 200) {
      capa.classList.add('tenace-qa--quieta');
    } else if (!enOjo) {
      capa.classList.remove('tenace-qa--quieta');
    }
  });
  document.addEventListener('mouseout', function (evento) {
    var tarjeta = evento.target.closest && evento.target.closest('.product-card');
    if (!tarjeta || (evento.relatedTarget && tarjeta.contains(evento.relatedTarget))) return;
    var capa = tarjeta.querySelector('.tenace-qa-capa');
    if (capa) capa.classList.remove('tenace-qa--quieta');
  });

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input.matches || !input.matches('form[data-tenace-qa] .tenace-qa-grupo input[type="radio"]')) return;
    var form = input.closest('form[data-tenace-qa]');
    preparar(form);
    actualizar(form, input);
    if (form.classList.contains('tenace-qa--pedir')) {
      // Mientras pide elegir, el aviso dice lo que aún falta ("Elige una opción"...)
      if (form.querySelector('input[name="id"]').value) {
        form.classList.remove('tenace-qa--pedir');
        aviso(form, '');
      } else {
        var fila = primeraFilaSinElegir(form);
        aviso(form, fila ? fila.getAttribute('data-aviso') : '');
      }
    } else {
      aviso(form, '');
    }
  });

  document.addEventListener('submit', function (event) {
    if (event.target.matches && event.target.matches('form[data-tenace-qa]')) event.preventDefault();
  });

  // Escape cierra el panel y el tabulador no sale de él mientras está abierto.
  document.addEventListener('keydown', function (event) {
    if (!abierta) return;
    if (event.key === 'Escape') { cerrarHoja(); return; }
    if (event.key !== 'Tab') return;
    var panel = hoja.querySelector('.tenace-qa-hoja-panel');
    var focos = Array.prototype.filter.call(
      panel.querySelectorAll('button:not([disabled]), input:not([disabled]):not([type="hidden"]), a[href]'),
      function (el) { return el.offsetParent !== null; }
    );
    if (!focos.length) return;
    var primero = focos[0];
    var ultimo = focos[focos.length - 1];
    if (!panel.contains(document.activeElement)) { event.preventDefault(); primero.focus(); return; }
    if (event.shiftKey && document.activeElement === primero) { event.preventDefault(); ultimo.focus(); }
    else if (!event.shiftKey && document.activeElement === ultimo) { event.preventDefault(); primero.focus(); }
  });

  document.addEventListener('click', function (event) {
    if (event.defaultPrevented || !event.target.closest) return;

    // Mientras el panel sube (400 ms) se ignoran sus toques: un doble toque en
    // "+" lo cerraba al caer en el fondo o marcaba una talla sin querer. Se
    // cancelan aquí (y no con pointer-events: none) para que tampoco lleguen a
    // la página de debajo.
    if (hoja && hoja.classList.contains('is-abriendo') && event.target.closest('#tenace-qa-hoja')) {
      event.preventDefault();
      return;
    }

    // Cerrar el panel
    if (event.target.closest('[data-tenace-qa-cerrar]')) { cerrarHoja(); return; }

    // "+" dentro de la foto (sin ratón)
    var mas = event.target.closest('[data-tenace-qa-mas]');
    if (mas) {
      event.preventDefault();
      var capa = mas.closest('.tenace-qa-capa');
      var formMas = capa && capa.querySelector('form[data-tenace-qa]');
      if (!formMas || mas.hasAttribute('data-tenace-qa-envio')) return;
      if (abierta && abierta.disparador === mas) return;
      preparar(formMas);
      // Con variantes, o agotado (en el panel se lee "Agotado"), abre el panel
      if (formMas.querySelector('.tenace-qa-grupo') || formMas.getAttribute('data-modo') === 'agotado') {
        abrirHoja(formMas, mas);
      } else {
        enviar(formMas, mas);
      }
      return;
    }

    // "Añadir al carrito"
    var boton = event.target.closest('[data-tenace-qa-boton]');
    if (!boton) return;
    var form = boton.closest('form[data-tenace-qa]');
    if (!form) return;
    event.preventDefault();
    if (boton.disabled || boton.hasAttribute('data-tenace-qa-envio')) return;

    preparar(form);
    if (form.querySelector('.tenace-qa-grupo')) actualizar(form);
    var campo = form.querySelector('input[name="id"]');
    if (!campo || !campo.value) {
      var fila = primeraFilaSinElegir(form);
      form.classList.add('tenace-qa--pedir');
      aviso(form, fila ? fila.getAttribute('data-aviso') : '');
      var primero = fila && fila.querySelector('input[type="radio"]:not(:disabled)');
      if (primero) primero.focus({ preventScroll: true });
      return;
    }
    enviar(form, boton);
  });
})();
